import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureFlagDialogComponent } from './feature-flag-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		GoMaterialModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		FeatureFlagDialogComponent
	],
	exports: [
		FeatureFlagDialogComponent
	]
})
export class FeatureFlagDialogComponentModule {}
